import { EARTH_RADIUS } from './constants'
import { Coordinate } from './types'

export function extractStreet(address: string) {
  const streetRegex = /(?:ул|пр|пер|б-р|бульвар|ш|шоссе|аллея|наб|пл)\..*$/i

  const match = address.match(streetRegex)

  if (match) {
    return match[0].trim()
  }

  return address
}

function degreesToRadians(degrees: number): number {
  return degrees * (Math.PI / 180)
}

export function calculateDistance(coord1: Coordinate, coord2: Coordinate): number {
  const dLat = degreesToRadians(Number(coord2.latitude) - Number(coord1.latitude))
  const dLon = degreesToRadians(Number(coord2.longitude) - Number(coord1.longitude))

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degreesToRadians(Number(coord1.latitude))) *
      Math.cos(degreesToRadians(Number(coord2.latitude))) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return EARTH_RADIUS * c
}

export function filterCoordinates<T>(coordinates: T[], center: Coordinate, radius: number): T[] {
  return coordinates.filter((coord) => calculateDistance(coord as Coordinate, center) <= radius)
}
